module.exports = __webpack_public_path__ + "img/video-thumb-8-fr.a11aa433.png";